import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

export default function ProgramOverview({program, isExpanded}) {

    const navigate = useNavigate()
    const [expanded, setExpanded] = useState(isExpanded ?? false)
    useEffect(() => {
        if (isExpanded !== undefined) setExpanded(isExpanded)
    }, [isExpanded])

    return(<>
        <div className="card standard-padding-s v-spacer-xs">
            <div className="flex space-between gap-xs center">
                <div>
                    <p className="card-title">Program Information</p>
                    <p className="card-label">Explore questionnaires & tracks.</p>
                </div>
                <button className="with-icon trailing outline" onClick={() => setExpanded(it => !it)}>
                    {expanded ? 'Collapse' : 'Expand'}
                    <span className="material-symbols-outlined scale-s vi-spacer-xxs">{expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</span>
                </button>
            </div>
            {expanded && <div className="showing vi-spacer-l">
                <p className="card-body medium">Questionnaire</p>
                {!program?.questionnaire && <p className="card-label v-spacer-l">This program isn't using questionnaire & automatic matching features.</p>}
                {program?.questionnaire && <div className="dashed-card justify-start gap-s columns padding-s v-spacer-xs vi-spacer-xs showing clickable" onClick={() => navigate(`questionnaire/${program.questionnaire.id}`)}>
                    <p className="card-title">{program.questionnaire.name}</p>
                    <p className="card-label uppercase neutral">Click To Explore</p>
                </div>}
                <p className="card-body medium v-spacer-xs">Tracks</p>
                <div className="grid gap-xs" style={{gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))'}}>
                    {program?.tracks?.map(track => <div className="dashed-card justify-start gap-s columns padding-s showing clickable" onClick={() => navigate(`track/${track.id}`)}>
                        <p className="card-body bold">{track.displayName}</p>
                        <p className="card-body">{track.description}</p>
                        <p className="card-label uppercase neutral">Click To Explore</p>
                    </div>)}
                </div>
            </div>}
        </div>
    </>)
}